import React from 'react';
import { AiOutlineDown, AiOutlineUp } from 'react-icons/ai';

const permissionTableColumns = () => {
  return [
    {
      accessor: 'name',
      Header: '메뉴/기능명',
      width: 400,
      Cell: ({ row }) => (
        <div
          {...row.getToggleRowExpandedProps({
            style: {
              paddingLeft: `${row.depth * 1}rem`,
              color: row.depth === 2 && '#777b7e',
            },
          })}
        >
          {row.values.name}
        </div>
      ),
    },
    {
      id: 'expander',
      width: 50,
      Cell: ({ row }) =>
        row.canExpand ? (
          <span
            {...row.getToggleRowExpandedProps({
              style: {
                textAlign: 'center',
              },
            })}
          >
            {row.isExpanded ? <AiOutlineUp /> : <AiOutlineDown />}
          </span>
        ) : null,
    },
  ];
};

export default permissionTableColumns;
